import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { LoginPage } from '../../contexts/identityaccess/presentation/pages/login';
import {
  AccountListPage,
  AccountDetailsPage,
  AccountEditPage,
  CreateAccountPage,
} from '../../contexts/identityaccess/presentation/pages/accounts';
import {
  ApiClientListPage,
  ApiClientCreatePage,
  ApiClientDetailsPage,
} from '../../contexts/identityaccess/presentation/pages/api-clients';
import { MessagingPage } from '../../contexts/messaging/presentation/pages';
import { DashboardPage } from '../pages/DashboardPage';
import { PrivateRoute } from './guards/PrivateRoute';
import { DashboardLayout } from '../layouts';

/**
 * AppRouter component
 * Defines application routes
 */
export const AppRouter: React.FC = () => {
  return (
    <Routes>
      {/* Public routes */}
      <Route path="/login" element={<LoginPage />} />

      {/* Protected routes wrapped with DashboardLayout */}
      <Route
        path="/*"
        element={
          <PrivateRoute>
            <DashboardLayout>
              <Routes>
                <Route path="/dashboard" element={<DashboardPage />} />
                <Route path="/accounts" element={<AccountListPage />} />
                <Route path="/accounts/new" element={<CreateAccountPage />} />
                <Route path="/accounts/:accountId" element={<AccountDetailsPage />} />
                <Route path="/accounts/:accountId/edit" element={<AccountEditPage />} />
                <Route path="/api-clients" element={<ApiClientListPage />} />
                <Route path="/api-clients/new" element={<ApiClientCreatePage />} />
                <Route path="/api-clients/:id" element={<ApiClientDetailsPage />} />
                <Route path="/messaging" element={<MessagingPage />} />
                {/* Future protected routes will be added here */}

                {/* Default redirect to dashboard */}
                <Route path="/" element={<Navigate to="/dashboard" replace />} />

                {/* 404 - redirect to dashboard */}
                <Route path="*" element={<Navigate to="/dashboard" replace />} />
              </Routes>
            </DashboardLayout>
          </PrivateRoute>
        }
      />
    </Routes>
  );
};
